export default __webpack_public_path__ + "static/media/notificationMosip.939c6f9b.mp3";